import { addHours, createDisplayDate, formatUserTime } from 'owa-datetime';
import type { ISelectableOption } from '@fluentui/react/lib/SelectableOption';

/**
 * Returns an array of tuples containing an hour of the day as key and its respective text.
 * @param minHour The minimum hour included in the array.
 * @param maxHour The maximum hour included in the array.
 */
export function getDisplayHours(minHour: number, maxHour: number): ISelectableOption[] {
    const date = createDisplayDate(0, 0, 0);

    const displayHours: ISelectableOption[] = [];
    for (let hour = minHour; hour <= maxHour; hour = hour + 0.5) {
        displayHours.push({
            key: hour,
            text: formatUserTime(addHours(date, hour)),
        });
    }

    return displayHours;
}
